import Cookies from "js-cookie";
import { getCsrfToken } from "@/app/_utils/csrf";

class CampaignService {
  static instance: CampaignService;

  csrfToken = getCsrfToken();
  tenant = Cookies.get("tenant") ?? "";
  baseUrl = `${import.meta.env.VITE_API_BASE_URL}`;

  getCampaignAsync = async (id: string) => {
    const res = await fetch(`${this.baseUrl}campaigns/${id}/`, {
      headers: { "Content-Type": "application/json" },
      credentials: "include",
    });
    return await res.json();
  };

  getCampaignsAsync = async () => {
    const res = await fetch(`${this.baseUrl}campaigns/`, {
      headers: { "Content-Type": "application/json" },
      credentials: "include",
    });
    return await res.json();
  };

  createCampaignAsync = async (template: any) => {
    const res = await fetch(`${this.baseUrl}campaigns/`, {
      method: "POST",
      body: JSON.stringify(template),
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": this.csrfToken,
      },
      credentials: "include",
    });

    return await res.json();
  };

  updateCampaignAsync = async (id: string, template: any) => {
    const res = await fetch(`${this.baseUrl}campaigns/${id}/`, {
      method: "PUT",
      body: JSON.stringify(template),
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": this.csrfToken,
      },
      credentials: "include",
    });

    return await res.json();
  };

  deleteCampaignAsync = async (id: string) => {
    return await fetch(`${this.baseUrl}campaigns/${id}/`, {
      method: "DELETE",
      headers: { "X-CSRFToken": this.csrfToken },
      credentials: "include",
    });
  };
}

export const campaignService = new CampaignService();
